module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1020.9971bd6b.png";